import React from "react";
import PropTypes from "prop-types";
import AsyncAutoComplete from "components/AsyncAutoComplete";
import loadHYHurdleTypesService from "services/hy/loadHYHurdleTypesService";

function SelectHYHurdleType({
  onSelect,
  disabled,
  error,
  placeholder,
  value,
  readOnly,
}) {
  return (
    <AsyncAutoComplete
      promiseFn={loadHYHurdleTypesService}
      onSelect={onSelect}
      textPath="name"
      labelPath="name"
      idPath="id"
      disabled={disabled}
      error={error}
      intent={!!error ? "danger" : null}
      placeholder={placeholder}
      value={value}
      readOnly={readOnly}
    />
  );
}

SelectHYHurdleType.propTypes = {
  value: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  initialValue: PropTypes.object,
  placeholder: PropTypes.string,
};

SelectHYHurdleType.defaultProps = {
  value: undefined,
  disabled: false,
  error: null,
  initialValue: {},
  placeholder: "Search...",
};

export default SelectHYHurdleType;
